<template>
    <div class="contactez_auteur">
        <h4>Contactez l'auteur</h4>
        <p>Par mail, c'est par
            <a href="" @click="setEmail" id="myMail">ici</a>.

        </p>
        <p>Sur <a target="_blank" href="https://twitter.com/BorisCassel">Twitter</a>.
        </p>

        <p>Sur <a target="_blank" href="https://www.linkedin.com/in/boris-cassel-99a35456">Linkedin</a>.</p>
    </div>
</template>

<script>
    export default{
        name:'contactMe',
        methods:{
            setEmail(){
                /* encodage mail par fonction btoa => evite installation server php*/
                const emailAddress= "mailto:" + atob("YXJuYXF1ZXNiaXpsZXNpdGVAZ21haWwuY29t");
                const link = document.getElementById("myMail");
                link.setAttribute('href', emailAddress);
            },
            setLinkedin(){
                var myLinkedin = document.getElementById("Linkedin")
                console.log("on ets bien dans linkedin")
                console.log(myLinkedin)
                myLinkedin.innerHTML('')
                myLinkedin.setAttribute("type", "IN/Share")
                console.log(myLinkedin)
                myLinkedin.setAttribute("data-url", "www.linkedin.com")
                console.log(myLinkedin)
            }
    }
    }
</script>

<style>

    .contactez_auteur{
        position:relative;
        display:flex;
        flex-direction:column;
        justify-content:center;
        height:30vh;


    }

    .contactez_auteur h4{
        font-family: Open Sans;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 33px;
        letter-spacing: 0px;
        text-align: left;
        margin-top:0;

    }


    .contactez_auteur p{
        font-family: Open Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: left;
        margin-bottom:2%;
    }


    @media screen and (max-width:1000px) {
        .contactez_auteur{
            position:relative;
            display:flex;
            flex-direction:column;
            justify-content:center;
            height:30vh;
            width:60vw;
            margin-top: 4vh;
        }
    }



</style>